module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-HeavyIt.311ea103.otf";